/* eslint-disable camelcase */
import { AxiosResponse } from 'axios'
import client from './client'

const getProjectList =
  (
    pageSize: number,
    page: number,
    chainId: number,
    tokenAddress?: string,
    ownerAddress?: string,
    search?: string,
    active?: number,
    feature?: number,
    infoVerify?: number,
    auditVerify?: number,
    emailVerify?: number,
    sortby?: 'rating' | 'total_vote' | 'total_participant' | 'created',
    order?: 'asc' | 'desc',
  ) =>
  async () => {
    const response = await client.request<AxiosResponse>({
      method: 'GET',
      url: `/projects/list`,

      params: {
        pageSize,
        page,
        chainId,
        tokenAddress,
        ownerAddress,
        search,
        active,
        feature,
        infoVerify,
        auditVerify,
        emailVerify,
        sortby,
        order,
      },
    })

    return response.data
  }

const getProjectDetail = (id: string) => async () => {
  const response = await client.request<AxiosResponse>({
    method: 'GET',
    url: `/projects/detail/${id}`,
  })

  return response.data
}

const createProject =
  ({
    email,
    tokenAddress,
    chainId,
    ownerAddress,
  }: {
    email: string
    tokenAddress: string
    chainId: number
    ownerAddress: string
  }) =>
  async (authHeaders: any) => {
    const response = await client.request<AxiosResponse>({
      method: 'POST',
      url: `/projects/create`,
      headers: authHeaders,
      data: {
        email,
        token_address: tokenAddress,
        chain_id: chainId,
        owner_address: ownerAddress,
      },
    })

    return response.data
  }

const updateProject =
  ({
    id,
    title,
    description,
    youtube_presentation,
    social,
    website,
    audit,
    logo,
    banner,
  }: {
    id: string
    title: string
    description: string
    youtube_presentation: string
    social: Array<{ channel: string; url: string }>
    website: string
    audit: Array<{ provider: string; url: string }>
    logo: string
    banner: string
  }) =>
  async (authHeaders: any) => {
    const response = await client.request<AxiosResponse>({
      method: 'PATCH',
      url: `/projects/update`,
      headers: authHeaders,
      data: {
        id,
        title,
        description,
        youtube_presentation,
        social,
        website,
        audit,
        logo,
        banner,
      },
    })

    return response.data
  }

const verifyEmail =
  ({ token }: { token: string }) =>
  async (authHeaders: any) => {
    const response = await client.request<AxiosResponse>({
      method: 'GET',
      url: `/projects/email`,
      headers: authHeaders,
      params: {
        token,
      },
    })

    return response.data
  }

export default {
  getProjectList,
  getProjectDetail,
  createProject,
  verifyEmail,
  updateProject,
}
